<template>
  <!-- name: '志愿者服务记录' -->
  <div class="volunteerWrap">
    <div class="topBox">
      <span class="iconClass" @click="$router.go(-1)"></span>
      志愿者服务记录
    </div>
    <img
      src="https://img.bbalt.cn/imgh5/other/volunteer_img.png"
      alt=""
      class="volunteer_img"
    />
    <div class="tabBox">
      <span
        :class="curTab === '衣物质检' ? 'actClass' : ''"
        @click="curTab = '衣物质检'"
        >衣物质检</span
      >
      <span
        :class="curTab === '一日店长' ? 'actClass' : ''"
        @click="curTab = '一日店长'"
        >一日店长</span
      >
    </div>
    <div class="totalBox">
      <div class="itemClass">
        <span>{{ time }}</span>
        <span>服务时间(小时)</span>
      </div>
      <div class="itemClass">
        <span>{{ count }}</span>
        <span>服务次数(次)</span>
      </div>
      <div class="itemClass">
        <span>{{ score }}</span>
        <span>积分</span>
      </div>
    </div>
    <div class="tableBox">
      <table>
        <div class="thBox">
          <th>日期</th>
          <th>时长</th>
          <th>质检数量</th>
          <th>装箱数量</th>
          <th>积分</th>
        </div>

        <tr v-for="(item, index) in tableList" :key="index">
          <td>{{ item.date }}</td>
          <td>{{ item.hours }}</td>
          <td>{{ item.qualityNum }}</td>
          <td>{{ item.binningNum }}</td>
          <td>{{ item.score }}</td>
        </tr>
      </table>
    </div>
    <button class="applyBtn">
      <img src="https://img.bbalt.cn/imgh5/other/icon_medal.svg" />申请证书
    </button>
    <button class="certBtn">
      <img src="https://img.bbalt.cn/imgh5/other/icon_certificate.svg" alt="" /><span
        >我的证书</span
      >
    </button>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      curTab: "衣物质检",
      time: "26.5",
      count: 67,
      score: 34637,
      tableList: [
        {
          date: "2021.11.23",
          hours: "3.8",
          qualityNum: "56",
          binningNum: "23",
          score: "190",
        },
        {
          date: "2021.11.23",
          hours: "3.8",
          qualityNum: "56",
          binningNum: "23",
          score: "190",
        },
        {
          date: "2021.11.23",
          hours: "3.8",
          qualityNum: "56",
          binningNum: "23",
          score: "190",
        },
        {
          date: "2021.11.23",
          hours: "3.8",
          qualityNum: "56",
          binningNum: "23",
          score: "190",
        },
        {
          date: "2021.11.23",
          hours: "3.8",
          qualityNum: "56",
          binningNum: "23",
          score: "190",
        },
        {
          date: "2021.11.23",
          hours: "3.8",
          qualityNum: "56",
          binningNum: "23",
          score: "190",
        },
      ],
    };
  },
  created() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.volunteerWrap {
  height: 100%;
  width: 100%;
  background: #f5f5f5;
  text-align: center;
  overflow: hidden;
  padding-bottom: 37px;
  display: flex;
  align-items: center;
  flex-flow: column;
  font-family: PingFang-SC, PingFang-SC;
  background-image: url("https://img.bbalt.cn/imgh5/other/bg_volunteer.png");
  background-repeat: no-repeat;
  background-size: 100% 560px;
  position: relative;
  font-family: PingFangSC, PingFang SC;
  .topBox {
    width: 100%;
    height: 96px;
    line-height: 96px;
    position: relative;
    font-size: 36px;
    font-weight: 400;
    color: #333333;
    .iconClass {
      position: absolute;
      top: 34px;
      left: 34px;
      &::before,
      &::after {
        position: absolute;
        content: "";
        border-top: 17px transparent dashed;
        border-left: 17px transparent dashed;
        border-bottom: 17px transparent dashed;
        border-right: 17px #fff solid;
      }
      &::before {
        border-right: 17px #333 solid;
      }
      &:after {
        left: 5px;
        border-right: 17px #cbd2ee solid;
      }
    }
  }
  .volunteer_img {
    position: absolute;
    top: 60px;
    left: 32px;
    width: 250px;
    height: 250px;
  }
  .tabBox {
    margin-top: 54px;
    margin-right: 32px;
    width: 100%;
    display: flex;
    justify-content: flex-end;

    span {
      display: inline-block;
      height: 83px;
      width: 180px;
      font-size: 28px;
      font-weight: 400;
      color: #666666;
      padding-top: 18px;
      &.actClass {
        background-image: url("https://img.bbalt.cn/imgh5/other/tab_seleted.svg");
        background-repeat: no-repeat;
        background-size: 100%;
        font-weight: 600;
        color: #333333;
      }
    }
  }
  .totalBox {
    width: 686px;
    height: 195px;
    background: #ffffff;
    border-radius: 16px;
    margin-top: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
    justify-content: space-evenly;
    margin-bottom: 16px;
    .itemClass {
      display: flex;
      flex-flow: column;
      justify-content: center;
      span {
        font-size: 24px;
        font-weight: 400;
        color: #999999;
        &:first-child {
          font-size: 40px;
          font-weight: 600;
          color: #928dcc;
          margin-bottom: 13px;
        }
      }
    }
  }
  .tableBox {
    width: 686px;
    max-height: 600px;
    overflow: auto;
    background: #ffffff;
    border-radius: 16px;
    table {
      width: calc(100% - 48px);
      margin: 32px 24px;
      border: 0px;
      display: flex;
      flex-flow: column;
      .thBox {
        width: 100%;
        background: rgba(254, 102, 166, 0.08);
        display: flex;
        justify-content: space-evenly;
      }
      th {
        height: 56px;
        line-height: 56px;
        font-size: 24px;
        font-weight: 400;
        color: #666666;
        border-spacing: 0px;
        text-align: left;
        width: 115px;
        margin-left: 12px;
        &:first-child {
          width: 140px;
          margin-left: 22px;
        }
      }
      tr {
        margin-top: 28px;
        display: flex;
        justify-content: flex-start;
        width: 100%;
        margin-left: 16px;
        td {
          text-align: left;
          width: 115px;
          margin-right: 12px;
          font-size: 28px;
          font-weight: 400;
          color: #333333;
          &:first-child {
            width: 140px;
            margin-right: 22px;
          }
        }
      }
    }
  }
  .applyBtn {
    position: absolute;
    bottom: 118px;
    width: 280px;
    height: 88px;
    background: #fe66a6;
    box-shadow: 0px 0px 12px 0px rgba(254, 102, 166, 0.3);
    border-radius: 47px;
    border: none;
    font-size: 32px;
    font-weight: 600;
    color: #ffffff;
    text-shadow: 0px 0px 12px rgba(254, 102, 166, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 40px;
      height: 40px;
      margin-right: 8px;
    }
  }
  .certBtn {
    width: 144px;
    height: 88px;
    background: #ffffff;
    box-shadow: 0px 0px 12px 0px rgba(204, 204, 204, 0.3);
    border-radius: 47px 0px 0px 47px;
    border: 1px solid #ededed;
    position: absolute;
    right: 0px;
    bottom: 118px;
    img {
      width: 40px;
      height: 40px;
      margin-right: 12px;
    }
    span {
      width: 48px;
      display: inline-block;
      height: 52px;
      font-size: 24px;
      font-weight: 400;
      color: #666666;
      line-height: 26px;
      text-shadow: 0px 0px 12px rgba(204, 204, 204, 0.3);
    }
  }
}
</style>
